module.exports = __webpack_public_path__ + "img/logo.aa3c4934.png";